import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LoadingProps {
    inline?: boolean;
    size?: "xs" | "lg" | "sm" | "1x" | "2x" | "3x" | "4x" | "5x" | "6x" | "7x" | "8x" | "9x" | "10x";
    label?: string;
}

const Loading = (props: LoadingProps) => {
    const childProps = {
        ...props,
        inline: null,
    } 
    const label = props.label ? props.label : "Loading";
    if (props.inline) {
        return <template style={{ display: "flex", alignItems: "center" }}>{label} &nbsp; <FontAwesomeIcon icon="spinner" {...childProps} spin /></template>
    }
    delete props.inline;
    return <span >{label} &nbsp; <FontAwesomeIcon icon="spinner" {...childProps} spin /></span>
};

export default Loading;
